import {mode} from "@chakra-ui/theme-tools";
export const globalStyles = {
  colors: {
    statusPill:{

    },
    // ─── Cosmos Design System ───────────────────────────────────────────
    // EV Ecosystem — primary brand palette
    brand: {
      50:  "#EAFBF5",
      100: "#C3E9DD",
      200: "#9BD9C4",
      300: "#73C9AB",
      400: "#4BB992",
      500: "#23A979",
      600: "#1C8D63",
      700: "#166F4E",
      800: "#0A3324",
      900: "#0A3324",
    },
    brandScheme: {
      50:  "#EAFBF5",
      100: "#C3E9DD",
      200: "#9BD9C4",
      300: "#73C9AB",
      400: "#4BB992",
      500: "#23A979",
      600: "#1C8D63",
      700: "#166F4E",
      800: "#0A3324",
      900: "#0A3324",
    },
    brandTabs: {
      50:  "#EAFBF5",
      100: "#C3E9DD",
      200: "#9BD9C4",
      300: "#73C9AB",
      400: "#4BB992",
      500: "#23A979",
      600: "#1C8D63",
      700: "#166F4E",
      800: "#0A3324",
      900: "#0A3324",
    },
    // EV Ecosystem alias (explicit)
    ev: {
      50:  "#EAFBF5",
      100: "#C3E9DD",
      200: "#9BD9C4",
      300: "#73C9AB",
      400: "#4BB992",
      500: "#23A979",
      600: "#1C8D63",
      700: "#166F4E",
      800: "#0A3324",
    },
    // Neutral Plate
    neutral: {
      50:  "#FFFFFF",
      100: "#F2F2F2",
      200: "#C4C4C4",
      300: "#949494",
      400: "#646464",
      500: "#343434",
      600: "#2B2B2B",
      700: "#212121",
      800: "#111111",
    },
    // Semantic — Success
    success: {
      50:  "#EEF8EC",
      100: "#B9E0B1",
      200: "#84C777",
      300: "#4FAE3D",
      400: "#377B2B",
      500: "#204719",
    },
    // Semantic — Error
    error: {
      50:  "#FCE8E8",
      100: "#F5AEAF",
      200: "#EE7475",
      300: "#E73A3B",
      400: "#A12729",
      500: "#5C1516",
    },
    // Semantic — Alert
    alert: {
      50:  "#FFF3E5",
      100: "#FFD0A9",
      200: "#FFAF6D",
      300: "#FF8E31",
      400: "#B26320",
      500: "#663710",
    },
    // Semantic — Warning
    warning: {
      50:  "#FFF8E5",
      100: "#FDE198",
      200: "#FACB4C",
      300: "#F7B500",
      400: "#AE7F00",
      500: "#644900",
    },
    // Semantic — Info
    info: {
      50:  "#E5F2FF",
      100: "#98C9FB",
      200: "#4C9FF7",
      300: "#0075F3",
      400: "#0052AA",
      500: "#002F62",
    },
    // ─── Legacy / kept for backward compat ──────────────────────────────
    secondaryGray: {
      100: "#E0E5F2",
      200: "#E1E9F8",
      300: "#F4F7FE",
      400: "#E9EDF7",
      500: "#8F9BBA",
      600: "#A3AED0",
      700: "#707EAE",
      800: "#707EAE",
      900: "#1B2559",
    },
    red: {
      100: "#FEEFEE",
      500: "#EE5D50",
      600: "#E31A1A",
    },
    blue: {
      50: "#EFF4FB",
      500: "#3965FF",
    },
    orange: {
      100: "#FFF6DA",
      500: "#FFB547",
    },
    green: {
      100: "#E6FAF5",
      500: "#01B574",
    },
    navy: {
      50: "#d0dcfb",
      100: "#aac0fe",
      200: "#a3b9f8",
      300: "#728fea",
      400: "#3652ba",
      500: "#1b3bbb",
      600: "#24388a",
      700: "#1B254B",
      800: "#111c44",
      900: "#0b1437",
    },
    gray: {
      100: "#FAFCFE",
    },
  },
  // ─── Cosmos Design System — Typography ──────────────────────────────
  fonts: {
    heading: "'DM Serif Display', serif",
    body:    "'Satoshi Variable', 'Satoshi', 'DM Sans', sans-serif",
    mono:    "monospace",
  },
  fontSizes: {
    // Design system tokens
    fsize_8:  "8px",
    fsize_10: "10px",
    fsize_12: "12px",
    fsize_14: "14px",
    fsize_16: "16px",
    fsize_20: "20px",
    fsize_24: "24px",
    fsize_28: "28px",
    fsize_32: "32px",
    fsize_36: "36px",
    fsize_40: "40px",
    fsize_44: "44px",
    fsize_48: "48px",
    fsize_56: "56px",
    fsize_64: "64px",
    fsize_72: "72px",
    fsize_84: "84px",
    fsize_96: "96px",
    // Chakra standard scale (mapped to design system)
    xs:   "10px",
    sm:   "12px",
    md:   "14px",
    lg:   "16px",
    xl:   "20px",
    "2xl": "24px",
    "3xl": "28px",
    "4xl": "32px",
    "5xl": "36px",
    "6xl": "40px",
    "7xl": "48px",
    "8xl": "64px",
    "9xl": "96px",
  },
  fontWeights: {
    thin:       100,
    extralight: 200,
    light:      300,
    normal:     400,
    medium:     500,
    semibold:   600,
    bold:       700,
    extrabold:  800,
    black:      900,
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: "hidden",
        bg: mode("secondaryGray.300", "navy.900")(props),
        fontFamily: "'Satoshi Variable', 'Satoshi', 'DM Sans', sans-serif",
        letterSpacing: "-0.5px",
      },
      input: {
        color: "gray.700",
      },
      html: {
        fontFamily: "'Satoshi Variable', 'Satoshi', 'DM Sans', sans-serif",
      },
      // Native date input calendar icon — override browser default orange
      "input[type='date']::-webkit-calendar-picker-indicator, input[type='datetime-local']::-webkit-calendar-picker-indicator": {
        filter: "invert(52%) sepia(77%) saturate(400%) hue-rotate(118deg) brightness(92%) contrast(87%)",
        cursor: "pointer",
      },
      // Global focus ring — override Chakra's default orange/blue
      "input:focus, input:focus-visible, select:focus, select:focus-visible, textarea:focus, textarea:focus-visible": {
        borderColor: "#23A979 !important",
        boxShadow: "0 0 0 1px #23A979 !important",
        outline: "none !important",
      },
    }),
  },
};
